import { render, staticRenderFns } from "./CasesDetails.vue?vue&type=template&id=64657c40&scoped=true"
import script from "./CasesDetails.vue?vue&type=script&lang=js"
export * from "./CasesDetails.vue?vue&type=script&lang=js"
import style0 from "./CasesDetails.vue?vue&type=style&index=0&id=64657c40&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64657c40",
  null
  
)

export default component.exports